import { render } from "./ScholarshipView.vue?vue&type=template&id=f5a72cda&scoped=true"
import script from "./ScholarshipView.vue?vue&type=script&lang=js"
export * from "./ScholarshipView.vue?vue&type=script&lang=js"

import "./ScholarshipView.vue?vue&type=style&index=0&id=f5a72cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a72cda"]])

export default __exports__